export default __webpack_public_path__ + "static/Inter-Bold-subset-379f2f655a927e3a2b0f3b2e31965970.woff2";